import React from "react";
import ScaleModal from "./ScaleConfirmationModal";
import MaxRecordExceededModal from "./MaxRecordExceededModal";
import MaxPrintRecordExceededModal from "./MaxPrintRecordExceededModal";
import DisclaimerModal from "./DisclaimerModal";
import ZoningNotificationModal from "./ZoningNotificationModal";
import ResetUserPasswordConfirmationModal from "./ResetUserPasswordConfirmationModal";
import DeleteUserConfirmationModal from "./DeleteUserConfirmationModal";
import EditUserModal from "./EditUserModal";
import AddUserModal from "./AddUserModal";
import { AddBlockedEmailModal } from "../../../../public-outreach-tool/src/components/Modals/AddBlockedEmailModal";
import NoRecordsFoundModal from "./NoRecordsFoundModal";
import Alert from "../Alert";
import { useStore } from "../../main";

export const ModalRoot = () => {
  const { config } = useStore();
  if (!config) return null;
  const visibleTools = config.toolbarOptions.visibleTools;
  if (!visibleTools) return null;
  return (
    <>
      {visibleTools["scale"] && <ScaleModal />}
      <MaxRecordExceededModal />
      <NoRecordsFoundModal />
      {visibleTools["disclaimer"] !== false && <DisclaimerModal />}
      {visibleTools["print"] && <MaxPrintRecordExceededModal />}
      <ZoningNotificationModal />
      <ResetUserPasswordConfirmationModal />
      <DeleteUserConfirmationModal />
      <EditUserModal />
      <AddUserModal />
      <AddBlockedEmailModal />
      <Alert />
    </>
  );
};
